var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_246",
    "data-name": "Group 246",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 34,
    height: 34,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M11.168,22.333A11.167,11.167,0,1,1,22.332,11.167,11.18,11.18,0,0,1,11.168,22.333M11.168,1A10.167,10.167,0,1,0,21.332,11.167,10.18,10.18,0,0,0,11.168,1",
    fill: "#25a0eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M11.168,11.667a.5.5,0,0,1-.5-.5v-6.9a.5.5,0,0,1,1,0v6.9a.5.5,0,0,1-.5.5",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M15.307,4.449a.462.462,0,0,1-.228-.061.456.456,0,0,1-.167-.622L15.18,3.3a.455.455,0,1,1,.789.455l-.268.464a.454.454,0,0,1-.394.228",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M6.756,19.261a.464.464,0,0,1-.226-.06.456.456,0,0,1-.17-.622l.266-.465a.456.456,0,0,1,.791.453l-.266.464a.456.456,0,0,1-.395.23",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M18.8,16.031a.464.464,0,0,1-.228-.061l-.46-.266a.455.455,0,0,1,.455-.789l.461.266a.455.455,0,0,1-.228.85",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M3.994,7.48a.458.458,0,0,1-.227-.061L3.3,7.153a.455.455,0,0,1,.453-.79l.465.266a.456.456,0,0,1-.227.851",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M7.025,4.449a.456.456,0,0,1-.395-.228l-.267-.464A.455.455,0,0,1,7.152,3.3l.268.464a.457.457,0,0,1-.167.622.462.462,0,0,1-.228.061",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M15.58,19.261a.454.454,0,0,1-.393-.226l-.272-.465a.456.456,0,0,1,.787-.459l.272.465a.456.456,0,0,1-.164.622.451.451,0,0,1-.23.063",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M3.529,16.031A.455.455,0,0,1,3.3,15.18l.464-.266a.456.456,0,0,1,.452.791l-.465.266a.464.464,0,0,1-.226.06",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M18.342,7.48a.455.455,0,0,1-.227-.85l.46-.266a.455.455,0,1,1,.456.788l-.461.266a.45.45,0,0,1-.228.062",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M2.883,11.621H2.347a.455.455,0,0,1,0-.91h.536a.455.455,0,0,1,0,.91",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M19.449,11.621a.455.455,0,0,1,0-.91l.539,0h0a.455.455,0,0,1,0,.91l-.539,0Z",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M11.164,20.44h0a.454.454,0,0,1-.452-.459l0-.537a.455.455,0,0,1,.455-.451h0a.454.454,0,0,1,.453.458l0,.537a.455.455,0,0,1-.455.452",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M11.166,3.337a.455.455,0,0,1-.455-.455V2.349a.455.455,0,0,1,.91,0v.533a.455.455,0,0,1-.455.455",
    fill: "#0d292d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M8.146,14.688a.5.5,0,0,1-.354-.854l2.9-2.9a.5.5,0,1,1,.708.707l-2.9,2.9a.5.5,0,0,1-.354.147",
    fill: "#0d292d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.bde135fb5dafcda9e863867518a72c27.svg";
export { ForwardRef as ReactComponent };